import { useJumpLastUrl } from '@!/Hooks'
import { VStack, Text, Box } from '@chakra-ui/react'
import { NormalButton } from '@!/components/Button'
import { ScrollableLatelyAccessList } from '@!/Store/Common/components/ScrollableLatelyAccessList'

export const PaymentComplete = (props) => {
  const jumpLastUrl = useJumpLastUrl()
  const { error, error_type, cancel } = props.params
  let text = 'コインの購入を完了しました。'
  if (cancel) {
    text = 'コインの購入をキャンセルしました。'
  } else if (error) {
    switch (error_type) {
      case 'coin_add_failure':
        text = '申し訳ありません、コインの付与に失敗しました。恐れ入りますが、メニューの「お問い合わせ」よりサポートまでご連絡ください。'
        break
      default:
        text = '決済に失敗しました。再度コイン購入を行ってください。'
    }
  }

  return (
    <VStack spacing={16} pt={16} pb={6}>
      <Text fontSize="sm">{text}</Text>
      <Box w="100%" px={4}>
        {cancel || error ? (
          <NormalButton onClick={() => (window.location.href = '/user/payment')}>コイン購入ページに戻る</NormalButton>
        ) : (
          <NormalButton onClick={jumpLastUrl}>元のページに戻る</NormalButton>
        )}
      </Box>
      <Box w="100%">
        <ScrollableLatelyAccessList />
      </Box>
    </VStack>
  )
}
